import React from 'react';
import { Link } from 'gatsby';
import './tag.css';

const Tag = ({ url, children }) => {
  return (
    <Link to={`/tags/${url.toLowerCase()}`} className="tag-link">{children}</Link>
  )
};

export default Tag;
